import React from "react";
import styled from "styled-components";
import { useCreateRoutingCallback } from "#shared/hooks";

const WithoutLayersButton = ({
    className,
    children,
    onClick,
    disabled,
    width,
    colors = ["rgb(239, 221, 199)", "#3C400C"],
}) => {
    const [first, second, optional] = colors;
    const routeToSignup = useCreateRoutingCallback("/signup", { refresh: true });
    return (
        <WithoutLayers
            onClick={onClick || routeToSignup}
            second={second}
            first={first}
            disabled={disabled}
            width={width}
            className={className}
            optional={optional}
        >
            {children}
        </WithoutLayers>
    );
};

const WithoutLayers = styled.button`
    min-width: ${({ width }) => width || "254px"};
    height: 71px;
    padding: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    line-height: 177%;
    font-family: Favoritmonostd, sans-serif;
    background: transparent;
    border: 2px ${({ first, optional }) => optional || first} solid;
    transform: translate3d(-8px, -8px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg);
    transform-style: preserve-3d;
    background-color: ${({ first }) => first};
    color: ${({ second }) => second};
    transition: 0.3s;
    text-transform: uppercase;

    :hover {
        cursor: pointer;
        outline: 0;
    }
    :focus {
        outline: 0;
    }
    :disabled {
        background: ${({ theme }) => theme.colors.lightGray};
    }
`;

WithoutLayersButton.styled = { WithoutLayers };

export default WithoutLayersButton;
